var React = require('react');

function Glass (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M93.8 448L73.22 160h237.55L290.2 448z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M317.63 64L290.2 448H93.8L66.37 64h251.26M352 0H32A32 32 0 0 0 0 32c0 .67 0 1.33.06 2l32 448A32 32 0 0 0 64 512h256a32 32 0 0 0 31.94-30l32-448A32 32 0 0 0 354 .06c-.67 0-1.34-.06-2-.06z","className":"fa-primary","key":2})]);
}

Glass.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Glass;

Glass.default = Glass;
